// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type CreateGuidedChangeEventModalQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type CreateGuidedChangeEventModalQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Region', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Market', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Community', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Subdivision', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Lot', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Structure', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Unit', id: string, shouldAccrueAsComplete: boolean, stage: { __typename?: 'ProjectStage', id: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
  , enumDetails: { __typename?: 'AllEnumDetails', changeEventWorkflow: Array<{ __typename?: 'ChangeEventWorkflowDetail', code: Types.ChangeEventWorkflow, name: string, description: string }> } };


export const CreateGuidedChangeEventModalDocument = gql`
    query CreateGuidedChangeEventModal($projectId: ID!) {
  project(id: $projectId) {
    id
    stage(stage: CONSTRUCTION) {
      id
    }
    lotType {
      code
      clientNoun
    }
    shouldAccrueAsComplete
  }
  enumDetails {
    changeEventWorkflow {
      code
      name
      description
    }
  }
}
    `;

/**
 * __useCreateGuidedChangeEventModalQuery__
 *
 * To run a query within a React component, call `useCreateGuidedChangeEventModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateGuidedChangeEventModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateGuidedChangeEventModalQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateGuidedChangeEventModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables> & ({ variables: CreateGuidedChangeEventModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>(CreateGuidedChangeEventModalDocument, options);
      }
export function useCreateGuidedChangeEventModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>(CreateGuidedChangeEventModalDocument, options);
        }
// @ts-ignore
export function useCreateGuidedChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>;
export function useCreateGuidedChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CreateGuidedChangeEventModalQuery | undefined, CreateGuidedChangeEventModalQueryVariables>;
export function useCreateGuidedChangeEventModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>(CreateGuidedChangeEventModalDocument, options);
        }
export type CreateGuidedChangeEventModalQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModalQuery>;
export type CreateGuidedChangeEventModalLazyQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModalLazyQuery>;
export type CreateGuidedChangeEventModalSuspenseQueryHookResult = ReturnType<typeof useCreateGuidedChangeEventModalSuspenseQuery>;
export type CreateGuidedChangeEventModalQueryResult = ApolloReactCommon.QueryResult<CreateGuidedChangeEventModalQuery, CreateGuidedChangeEventModalQueryVariables>;